"use client"
import React, { useState } from 'react';
import SubscribeService from '@/app/services/subscribe';
import toast from "react-hot-toast";
import { useTranslations } from 'next-intl';

const ContactForm = () => {
    const t = useTranslations("General");
    const [isLoading, setIsLoading] = useState<boolean>(false)

    async function sendMessageToCompany(e: React.FormEvent<HTMLFormElement>) {
        setIsLoading(true)
        e.preventDefault();
        const form = e.currentTarget;
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        try {
            const result: any = await SubscribeService.sendMessage(data);
            if (result?.data?.success) {
                toast.success(t('message_sent_success'));
                form.reset()
            } else {
                toast.error(result?.data?.message ?? t('message_sent_error'))
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? t('message_sent_error'))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className="p-8 flex-1">
            <form onSubmit={sendMessageToCompany} method="POST" className="space-y-2">
                <div className="grid grid-cols-1 gap-6">
                    <div>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            autoComplete="given-name"
                            className="mt-1 block w-full border-gray-300 p-3 border-b-1"
                            placeholder="Name"
                        />
                    </div>

                    <div>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            autoComplete="email"
                            required
                            className="mt-1 block w-full border-gray-300 p-3 border-b-1"
                            placeholder="Email"
                        />
                    </div>
                    <div>
                        <input
                            type="text"
                            name="subject"
                            id="subject"
                            required
                            className="mt-1 block w-full border-gray-300 p-3 border-b-1"
                            placeholder="Subject"
                        />
                    </div>

                </div>

                <div>
                    <textarea
                        id="message"
                        name="message"
                        rows={4}
                        required
                        className="mt-1 block w-full border-gray-300 p-3 border-b-1"
                        placeholder="Message"
                    />
                </div>

                <div className="flex justify-end">
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="inline-flex cursor-pointer justify-center py-2 px-6 border border-transparent text-base font-medium text-white transition duration-150 bg-primary-gradient w-full"
                    >
                        {isLoading ? t('sending_message') : t('send_request')}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default ContactForm;